import {NEUTRAL_PLAYER_COLOR, NEUTRAL_PLAYER_ID} from "../../constants/players";

export const getNeutralPlayerMock = () => {
  return {
    id: NEUTRAL_PLAYER_ID,
    color: NEUTRAL_PLAYER_COLOR,
  }
}